export const SENTRYTAGS = {
    LIVEVIEW: 'live-view',
    STATION: 'station',
    TRAJECTORY: 'trajectory',
    SEARCHCONFIG: 'search-config',
    MLP: 'mlp',
    LOT: 'lot',
    DEVICECONFIG: 'device-config'
}
